import { RouteResponse } from "@0xsquid/sdk/dist/types";
import { useMemo } from "react";
import { useConfigStore } from "../store/useSquidStore";

export const useEstimatePriceImpact = ({
  squidRoute,
}: {
  squidRoute: RouteResponse["route"] | undefined;
}) => {
  const config = useConfigStore((state) => state.config);

  const priceImpact: string | undefined = useMemo(() => {
    const priceImpact = squidRoute?.estimate?.aggregatePriceImpact;

    if (priceImpact == null) return;

    return Number(priceImpact).toFixed(2);
  }, [squidRoute?.estimate.aggregatePriceImpact]);

  const priceImpactStatus = useMemo(() => {
    if (config.priceImpactWarnings !== undefined && priceImpact !== undefined) {
      if (
        +priceImpact >= config.priceImpactWarnings.warning &&
        +priceImpact < config.priceImpactWarnings.critical
      ) {
        return "warning";
      }
      if (+priceImpact >= config.priceImpactWarnings.critical) {
        return "critical";
      }
      if (+priceImpact < config.priceImpactWarnings.warning) {
        return "normal";
      }
    }
    return undefined;
  }, [config.priceImpactWarnings, priceImpact]);

  return {
    priceImpact,
    priceImpactStatus,
  };
};
